import vars from './vars'
import MessageBubble from './MessageBubble'
import Loader from './Loader'

export {
  vars,
  MessageBubble,
  Loader
}



// WEBPACK FOOTER //
// ./src/ChatWidget/components/common/index.js